import React from "react";
const TransactionIcon = () => {
    return (
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.5832 14.4916L15.4082 18.675" stroke="#A4A4A4" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.4165 14.4916H19.5832" stroke="#A4A4A4" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.4165 9.50835L9.5915 5.32501" stroke="#A4A4A4" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M19.5832 9.50836H5.4165" stroke="#A4A4A4" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        </svg>


    );
};

export default TransactionIcon;
